import { detectTouch } from "../../service/detect-touch";

if (detectTouch()) {
  document.body.classList.add("body_touch");
} else {
  document.body.classList.add("body_no-touch");
}

export const blockBody = () => {
  document.body.classList.add("body_blocked");
};

export const unblockBody = () => {
  document.body.classList.remove("body_blocked");
};
